import React from 'react'

function RUB({ className, size }) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={size ?? 32}
      height={size ?? 32}
      fill='none'
      viewBox='0 0 32 32'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z'
        fill='#00B26B'
      />
      <path
        d='M17.5668 18.4807C21.9763 18.4807 24.5 16.0508 24.5 12.5326C24.5 9.13631 22.0326 6.5 17.5668 6.5H10.324V15.6192H7.5V18.4807H10.324V19.9067H7.5V22.7682H10.324V25.7141H13.7953V22.7682H18.0077V19.9067H13.7953V18.4807H17.5668ZM13.7953 15.6192V9.38962H17.5668C19.9029 9.38962 21.0287 10.7594 21.0193 12.5607C21.0287 14.3996 19.9216 15.6192 17.4917 15.6192H13.7953Z'
        fill='white'
      />
    </svg>
  )
}

export default RUB
